<div class="pop-up-container">
    <div class="container d-flex flex-row-reverse">
        <div class="offset-sm-2"></div>
        <div [hidden]="isHelpBubbleHidden()" class="pop-up-bubble">
            @if (walkThroughLink != null) {
                <p>
                    <strong> Click our
                        <a [href]="walkThroughLink.url"
                           rel="noopener noreferrer"
                           target="_blank">{{ walkThroughLink.name }}
                        </a>
                        or check our
                        <a [routerLink]="routes.PUBLIC.FAQS.path" rel="noopener noreferrer" target="_blank">FAQs</a>
                        for sign-up help. </strong>
                </p>
            } @else {
                <p>
                    <strong> Click here for a
                        <a [routerLink]="[routes.PUBLIC.SIGNUPWALKTHROUGH.path]"
                           rel="noopener noreferrer"
                           target="_blank">
                            walkthrough
                        </a>
                        or check our
                        <a [routerLink]="routes.PUBLIC.FAQS.path" rel="noopener noreferrer" target="_blank">FAQs</a>
                        for more information </strong>
                </p>
            }
        </div>
    </div>
</div>

<div class="container">
    <div [class.logo-centered]="mode === SignupMode.TRIMMED" class="row logo">
        <a>
            @if (mode === SignupMode.TRIMMED && gatewayLogoSrc) {
                <img [ngSrc]="gatewayLogoSrc"
                     alt="Pay@Gateway logo" class="gateway-logo" height="60" width="394" priority/>
            } @else {
                <img [ngSrc]="logoSecondary | assetSource" alt="App logo" height="30" width="40"/>
            }
        </a>
    </div>

    <div class="row">
        @if (this.isWalkthrough) {
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <app-product-walkthrough [lastStepIndex]="lastStepIndex"></app-product-walkthrough>
                    </div>
                </div>
            </div>
        }

        @if (!this.isWalkthrough) {
            <div class="col-10 offset-1 col-xs-12">
                <app-alert></app-alert>
                <div class="card" [class.card-trimmed]="mode === SignupMode.TRIMMED">
                    <div class="card-title">
                        <h1>Sign Up</h1>
                        @if (mode === SignupMode.FULL) {
                            <div class="mt-4">
                                <p-steps [activeIndex]="getCurrentSignupStep()"
                                         [model]="signupSteps"
                                         [readonly]="true"></p-steps>
                            </div>
                        }
                    </div>
                    <div class="card-body">
                        <div>
                            @if (mode === SignupMode.FULL) {
                                <app-signup-step1-full (nextPage)="processNext($event)"
                                                       (signupEvent)="onSignupDetailSubmission($event)"
                                                       [hidden]="getCurrentSignupStep() !== 0"
                                                       [isIntegratorSignup]="getIsIntegratorSignup()"
                                                       [isMerchantSelfServiceEnabled]="getIsMerchantSelfServiceEnabled() || getIsIntegratorSignup()"
                                                       [prefilledSignupDetail]="signupDetail"></app-signup-step1-full>
                                <app-kyc-form (kycDetail)="onKycDetailSubmission($event)"
                                              (nextPage)="processNext($event)"
                                              (previousPage)="processPrevious()"
                                              [businessTypeSubject]="getBusinessTypeSubject()"
                                              [captureNatureOfBusiness]="true"
                                              [directorNameSubject]="getDirectorNameSubject()"
                                              [directorSurnameSubject]="getDirectorSurnameSubject()"
                                              [hidden]="getCurrentSignupStep() !== 1"
                                              [integratorPrefix]="getIntegratorPrefix()"
                                              [prefilledKycDetail]="kycDetail"></app-kyc-form>
                                <app-avs-form (bankingDetail)="onBankingDetailsSubmission($event)"
                                              (nextPage)="processNext($event)"
                                              (previousPage)="processPrevious()"
                                              [hidden]="getCurrentSignupStep() !==2"
                                              [prefilledBankDetail]="bankingDetails"
                                              [refreshBranchAfterBankLoad]="true"></app-avs-form>
                                <app-address-form (addressDetail)="onAddressDetailSubmission($event)"
                                                  (previousPage)="processPrevious()"
                                                  [hidden]="getCurrentSignupStep() !==3"
                                                  [prefilledAddressDetail]="addressDetail"></app-address-form>
                            } @else {
                                <app-signup-step1-trimmed (nextPage)="processNext($event)"
                                                          (signupEvent)="onSignupDetailSubmission($event)"
                                                          [hidden]="getCurrentSignupStep() !== 0"
                                                          [isIntegratorSignup]="getIsIntegratorSignup()"
                                                          [isMerchantSelfServiceEnabled]="getIsMerchantSelfServiceEnabled() || getIsIntegratorSignup()"
                                                          [prefilledSignupDetail]="signupDetail"></app-signup-step1-trimmed>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
<ngx-ui-loader [text]="loaderText"></ngx-ui-loader>